import {PageableDto, PermissionTypeEnum, RoleDto, RoleNameEnum} from "./common";
import {OrganizationModel} from "./organization";
import {FacilityModel} from "./facility";

export enum UserTypeEnum {
  RESIDENT = "RESIDENT",
  CLERK = "CLERK",
  ADMINISTRATOR = "ADMINISTRATOR",
}
export enum UserNotificationChannelEnum {
  EMAIL = "EMAIL",
  SMS = "SMS",
}
export enum UserStatusEnum {
  ACTIVE = "ACTIVE",
  DELETED = "DELETED",
  NEW = "NEW",
}

export enum UserPermissionEnum {
  ADMISSION_COMPLETION_RATE = "ADMISSION_COMPLETION_RATE",
  PATIENTS_WITH_MEDICAL_SUPPLEMENT = "PATIENTS_WITH_MEDICAL_SUPPLEMENT",
  PATIENTS_WITHOUT_MEDICAL_SUPPLEMENT = "PATIENTS_WITHOUT_MEDICAL_SUPPLEMENT",
  TRUST_FUND_POLICY = "TRUST_FUND_POLICY",
  ADMISSIONS_WITH_ADVANCED_DIRECTIVES = "ADMISSIONS_WITH_ADVANCED_DIRECTIVES",
  RESIDENTS_ACCEPTED_OBRA_WITHIN_24_72_HOURS = "RESIDENTS_ACCEPTED_OBRA_WITHIN_24_72_HOURS",
  LAUNDRY_CONSENT = "LAUNDRY_CONSENT",
  SURROGATE_DECISION_RESIDENTS_REQUESTING_FOR_MORE_INFORMATION = "SURROGATE_DECISION_RESIDENTS_REQUESTING_FOR_MORE_INFORMATION",
  ADMISSION_IN_TOTAL = "ADMISSION_IN_TOTAL",
  AVG_TIME_SPENT_TO_CLOSE_ADMISSION = "AVG_TIME_SPENT_TO_CLOSE_ADMISSION",
  ESTIMATED_COST_TRACKED_BY_ROLE_AND_DATE = "ESTIMATED_COST_TRACKED_BY_ROLE_AND_DATE",
  ARBITRATION_AGREEMENT = "ARBITRATION_AGREEMENT",
  SLIDE_INTERACTIONS = "SLIDE_INTERACTIONS",
  READMISSION_RATE = "READMISSION_RATE",
  AGE_OF_HELP_FLAGS = "AGE_OF_HELP_FLAGS",
  INCOMES_AND_PERSONAL_RESOURCE = "INCOMES_AND_PERSONAL_RESOURCE",
  MOST_FREQUENTLY_FLAGGED_SLIDES = "MOST_FREQUENTLY_FLAGGED_SLIDES",
  COMPLETION_RATE_OF_ADMISSION_UNDER_90 = "COMPLETION_RATE_OF_ADMISSION_UNDER_90",
  FUNERAL = "FUNERAL",
  MEDICARE_WAIVER = "MEDICARE_WAIVER",
  SURROGATE_DECISION_MAKING = "SURROGATE_DECISION_MAKING",
  ADMISSIONS_COMPLETED_WITH_REPRESENT = "ADMISSIONS_COMPLETED_WITH_REPRESENT",
  AVG_TIME_SPENT_OF_EACH_STAGE_OF_ADMISSION = "AVG_TIME_SPENT_OF_EACH_STAGE_OF_ADMISSION",
  PNEUMOCOCCAL_AND_INFLUENZA_VACCINES = "PNEUMOCOCCAL_AND_INFLUENZA_VACCINES",
  PNEUMOCOCCAL_VACCINES = "PNEUMOCOCCAL_VACCINES",
  INFLUENZA_VACCINES = "INFLUENZA_VACCINES",
  RESIDENTS_REQUESTING_APPLICATION_FROM_MEDICAID = "RESIDENTS_REQUESTING_APPLICATION_FROM_MEDICAID",
  RESIDENTS_REQUESTING_FOR_HELP_WITH_CREATING_ADVACED_DIRECTIVE = "RESIDENTS_REQUESTING_FOR_HELP_WITH_CREATING_ADVACED_DIRECTIVE",
  ARBITRATION_AGREEMENT_COMPLETED = "ARBITRATION_AGREEMENT_COMPLETED",
  CONTRACT_SIGN = "CONTRACT_SIGN",
  ANALYTICS_ADMISSION_IN_TOTAL = "ANALYTICS_ADMISSION_IN_TOTAL",
  APPROVED_ARCHIVED_ADMISSIONS = "APPROVED_ARCHIVED_ADMISSIONS",
  RESIDENTS_WITH_MANAGED_MEDICAID = "RESIDENTS_WITH_MANAGED_MEDICAID",
  RESIDENTS_WITH_DNR = "RESIDENTS_WITH_DNR",
  EXISTING_ADVANCED_DIRECTIVE_PROVIDED = "EXISTING_ADVANCED_DIRECTIVE_PROVIDED",
  FACILITY_CHANGES = "FACILITY_CHANGES",
  ESTIMATED_COST_TRACKED_BY_FACILITY = "ESTIMATED_COST_TRACKED_BY_FACILITY",
  PAYER_SOURCE_AGE_65_75 = "PAYER_SOURCE_AGE_65_75",
  PAYER_SOURCE_AGE_75_85 = "PAYER_SOURCE_AGE_75_85",
  PAYER_SOURCE_AGE_85 = "PAYER_SOURCE_AGE_85",
  COMPLETION_TIME = "COMPLETION_TIME",
  COMPLETION_OVERALL = "COMPLETION_OVERALL",
  PHOTOS = "PHOTOS",
  STAFF_ADMISSIONS = "STAFF_ADMISSIONS",
  CRIMINAL_RECORD_CHECKBOX = "CRIMINAL_RECORD_CHECKBOX",
  COPY_OF_SURROGATE_CHECKBOX = "COPY_OF_SURROGATE_CHECKBOX",
  ADVANCED_DIRECTIVE_CHECKBOX = "ADVANCED_DIRECTIVE_CHECKBOX",
  OBRA_CHECKBOX = "OBRA_CHECKBOX",
  PERCENTAGE_OF_ADMISSIONS_COMPLETED_BY_REPRESENTATIVE = "PERCENTAGE_OF_ADMISSIONS_COMPLETED_BY_REPRESENTATIVE",
  COMPLETION_RATE_ONCE_ADMISSION_IS_SIGNED = "COMPLETION_RATE_ONCE_ADMISSION_IS_SIGNED",
  CHECKLIST_ITEMS = "CHECKLIST_ITEMS",
  QUICKSIGHT_DASHBOARDS = "QUICKSIGHT_DASHBOARDS",
}

export interface UserDto {
  readonly id: string;
  readonly code: string;
  readonly created: string;
  readonly email?: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly phone?: string;
  readonly role: RoleDto;
  readonly status: UserStatusEnum;
  readonly type: UserTypeEnum;
  readonly updated?: string;
  readonly version: number;
  readonly notificationChannel: UserNotificationChannelEnum;
  readonly organization?: OrganizationModel;
  readonly facilities?: ReadonlyArray<FacilityModel>;
  readonly permissions?: ReadonlyArray<UserPermissionDto>;
  readonly isSsoUser?: boolean;
  readonly dashboards?: ReadonlyArray<UserDashboardDto>;
}

export interface CreateStaffUserDto {
  readonly email: string;
  readonly facilities?: ReadonlyArray<string>;
  readonly firstName: string;
  readonly generatePassword?: boolean;
  readonly lastName: string;
  readonly organizationId?: string;
  readonly phone: string;
  readonly roleId?: string;
  readonly type: UserTypeEnum;
}

export interface CreateStaffUserResponseDto {
  readonly password: string;
  readonly token: string;
  readonly user?: UserDto;
  readonly username: string;
}

export interface ProfileUserDto {
  readonly firstName?: string;
  readonly lastName?: string;
  readonly phone?: string;
}

export interface UpdateStaffDto {
  readonly email: string;
  readonly facilities?: ReadonlyArray<string>;
  readonly firstName: string;
  readonly lastName: string;
  readonly organizationId?: string;
  readonly phone: string;
  readonly roleId?: string;
}

export interface ChangePasswordDto {
  readonly confirmPassword: string;
  readonly password: string;
  readonly token: string;
}

export interface ChangeUserPasswordDto {
  readonly confirmPassword: string;
  readonly oldPassword: string;
  readonly password: string;
}

export interface CreateResetPasswordDto {
  readonly email: string;
}

export interface VerificationUserDto {
  readonly confirmPassword: string;
  readonly password: string;
  readonly token: string;
}

export interface VerifyAccountDto {
  readonly result: boolean;
  readonly user: UserDto;
}

export interface UserPermissionDto {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly type: PermissionTypeEnum;
}

export interface ParametersDto {
  readonly facilityIds?: ReadonlyArray<string>;
  readonly pageable?: PageableDto;
  readonly roles?: ReadonlyArray<RoleNameEnum>;
  readonly statuses?: ReadonlyArray<UserStatusEnum>;
}

export interface TableUserFacilityDto {
  readonly id?: string;
  readonly name?: string;
}

export interface TableUserOrganizationDto {
  readonly name?: string;
  readonly hasSsoConfig?: {ssoEntryExists: boolean; ssoIsEnabled: boolean};
}

export interface UserDashboardDto {
  readonly id: string;
  readonly name: string;
}

export interface TableUserDto {
  readonly code?: string;
  readonly email?: string;
  readonly facilities?: ReadonlyArray<TableUserFacilityDto>;
  readonly firstName?: string;
  readonly id?: string;
  readonly lastName?: string;
  readonly organization?: TableUserOrganizationDto;
  readonly permissions?: ReadonlyArray<UserPermissionEnum>;
  readonly phone?: string;
  readonly role?: RoleNameEnum;
  readonly status?: UserStatusEnum;
  readonly isSsoUser?: boolean;
  readonly dashboards?: ReadonlyArray<UserDashboardDto>;
}
